import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import BlogArticle from "@/pages/blog/article1/page";
import BlogBezpieczenstwo from "@/pages/blog/bezpieczenstwo/page";
import BlogSneakers from "@/pages/blog/sneakers/page";
import BlogJakKorzystac from "@/pages/blog/jak-korzystac/page";
import BlogNajlepszeProdukty from "@/pages/blog/najlepsze-produkty/page";
import BlogHoodie from "@/pages/blog/hoodie/page";
import BlogPoczatkujacy from "@/pages/blog/poczatkujacy/page";
import BlogWysylka from "@/pages/blog/wysylka/page";
import BlogOpinie from "@/pages/blog/opinie/page";
import BlogFinds from "@/pages/blog/finds/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/blog/kakobuy-spreadsheet-polska-przewodnik",
    element: <BlogArticle />,
  },
  {
    path: "/blog/kakobuy-bezpieczenstwo",
    element: <BlogBezpieczenstwo />,
  },
  {
    path: "/blog/kakobuy-sneakers-spreadsheet",
    element: <BlogSneakers />,
  },
  {
    path: "/blog/kakobuy-jak-korzystac",
    element: <BlogJakKorzystac />,
  },
  {
    path: "/blog/najlepsze-produkty-kakobuy",
    element: <BlogNajlepszeProdukty />,
  },
  {
    path: "/blog/kakobuy-hoodie-spreadsheet",
    element: <BlogHoodie />,
  },
  {
    path: "/blog/kakobuy-dla-poczatkujacych",
    element: <BlogPoczatkujacy />,
  },
  {
    path: "/blog/kakobuy-wysylka-polska",
    element: <BlogWysylka />,
  },
  {
    path: "/blog/kakobuy-opinie-recenzje",
    element: <BlogOpinie />,
  },
  {
    path: "/blog/kakobuy-finds-polska",
    element: <BlogFinds />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;